import { appstr } from "./appstr";

export function Sappstr(strCode) {
  const localizedString = appstr(strCode);
  return (
    localizedString.charAt(0).toLocaleUpperCase() + localizedString.slice(1).toLocaleLowerCase()
  );
}
